import { CalendarTileProps } from './types';

/**
 * Custom tile content displayed in each tile of the calendar; adds some accessibility props.
 */
export const CalendarTile = ({ date, isSelected }: CalendarTileProps) => {
  // formats the aria-label to match what the cypress tests are looking for.
  const ariaLabel = date.toLocaleDateString(undefined, {
    month: '2-digit',
    year: 'numeric',
    day: '2-digit',
  });
  return (
    <div
      data-test="calendar-tile-date"
      aria-selected={isSelected}
      aria-label={isSelected ? `Selected. ${ariaLabel}` : ariaLabel}
    >
      {date.getDate()}
    </div>
  );
};
